import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { Outlet, useNavigation } from "react-router";
import { useState } from "react";
import { SideMenu } from "@/components/side-menu/SideMenu";
import { SidePanelSlotContext } from "@/components/SidePanel";
import { DevEnvironmentBanner } from "@/components/DevEnvironmentBanner";

/** The app's frame: the dev environment strip on top, then the side menu, a page's side panel (if open) and the page, which scrolls on its own. */
export function RootLayout() {
  const navigation = useNavigation();
  const [sidePanelSlot, setSidePanelSlot] = useState<HTMLElement | null>(null);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
      }}
    >
      <DevEnvironmentBanner />
      <Box
        sx={{
          display: "flex",
          flex: 1,
          minHeight: 0,
        }}
      >
        {navigation.state !== "idle" && (
          <LinearProgress
            color="secondary"
            sx={{
              left: 0,
              position: "fixed",
              right: 0,
              top: 0,
              zIndex: (theme) => theme.zIndex.appBar,
            }}
          />
        )}

        <SidePanelSlotContext.Provider value={sidePanelSlot}>
          <SideMenu />
          <Box
            ref={setSidePanelSlot}
            sx={{
              display: "flex",
              flexShrink: 0,
            }}
          />
          <Box
            component="main"
            sx={{
              bgcolor: "background.default",
              flex: 1,
              minWidth: 0,
              overflowY: "auto",
            }}
          >
            <Container
              maxWidth={false}
              disableGutters            
            >
              <Outlet />
            </Container>
          </Box>
        </SidePanelSlotContext.Provider>
      </Box>
    </Box>
  );
}
